import React from 'react'
import CheckBox from '@Components/Selectors/Checkbox'
import { IMyUserGroups } from '@Components/AddNewUserSub'

interface NewUserPermissionGroupProps {
    myUserGroups: IMyUserGroups[]
    onCheckGroup: (index: number) => void
}

const GROUP_HELPER_TEXT: Record<string, string> = {
    Copyright:
        'Grants user access to copyright-related features only, such as ' +
        'viewing, editing and creating works in the Member’s catalog. ' +
        'Cannot see user permissions or banking information.',
    Finance:
        'Grants user access to finance-related features only, such as ' +
        'managing banking and tax information for a Member. ' +
        'Cannot view, edit or create works.',
    'Super User':
        'Grants user full access. User can take all actions on works in the ' +
        'Member’s catalog, can manage User Permissions and Member account information.',
}

const NewUserPermissionGroup = ({ myUserGroups, onCheckGroup }: NewUserPermissionGroupProps) => (
    <div className="permissions-group">
        {myUserGroups.map((item: IMyUserGroups, index: number) => {
            const helperText = GROUP_HELPER_TEXT[item.name]

            if (!helperText) {
                return
            }

            return (
                <CheckBox
                    id={item.name}
                    key={item.name}
                    mainColor
                    onClick={() => onCheckGroup(index)}
                    checked={item.checked}
                    text={item.name}
                    disabled={item.disabled}
                    labelInfo={helperText}
                />
            )
        })}
    </div>
)

export default NewUserPermissionGroup
